import { useEffect } from "react";
import { initOneTrustScripts } from "./OneTrustScripts";

export function useOneTrustInitializer(domainScript?: string): void {
  useEffect(() => {
    initOneTrustScripts(domainScript);
  }, [domainScript]);
}
